
export const SellerSizeGuidesQuery = new TypedDocumentString(`
    query SellerSizeGuidesQuery($input: InputPagination!, $sellerId: ObjectId!) {
  publicSizeGuides(input: $input, sellerId: $sellerId) {
    info {
      ...PaginationInfo
      __typename
    }
    items {
      _id
      title {
        value
        __typename
      }
      image {
        ...Image
        __typename
      }
      __typename
    }
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment PaginationInfo on PaginationInfo {
  pageInfo {
    ...PageInfo
    __typename
  }
  sorting {
    name
    field
    __typename
  }
  filters {
    key
    name
    type
    options {
      number {
        min
        max
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment PageInfo on PageInfo {
  totalCount
  totalPageCount
  pageSize
  currentPage
  hasPrevious
  hasNext
  __typename
}`, {"hash":"2f30ec62362ad4abaa3881702d1e75944a89cd066390d426a52fb84801ab00b2"});